import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import Link from '@swf/components/Link/Link';
import type { Props } from '@swf/components/StarsButton/StarsButton';
import Button from '@swf/components/StarsButton/StarsButton';
import Arrow from '@swf/core/assets/icons/arrow.svg';

import { TXTCLI_More } from './CasinoAllButton.messages.json';
import styles from './CasinoAllButton.scss';

const CasinoAllButton: React.FC<Props> = (props) => (
  <>
    <Link {...props} className={classNames(styles.allLink, props.className)}>
      <Translation {...TXTCLI_More} />
      <Arrow />
    </Link>
    <Button
      {...props}
      variant="casino"
      size="small"
      className={classNames(styles.allButton, props.className)}
      translation={TXTCLI_More}
    />
  </>
);

export default CasinoAllButton;
